import * as React from "react";

import Fade from "./Fade";
import clsx from "clsx";

function handleOutsideClick(setClick, ref) {
    React.useEffect(() => {
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setClick(false);
            }
        };
        document.addEventListener("mouseup", handleClickOutside);
        return () => {
            document.removeEventListener("mouseup", handleClickOutside);
        };
    }, [ref]);
}

interface TooltipProps {
    open?: boolean;
    setOpen?: (open: boolean) => void;
    tooltipIsOnMap?: boolean;
    onlyClick?: boolean;
    direction?: "top" | "right" | "bottom" | "left";
    hoverElement?: React.ReactNode;
    classes?: { container?: string };
}

const Tooltip: React.FC<TooltipProps> = ({
    tooltipIsOnMap = false,
    direction = "right",
    onlyClick = false,
    ...props
}) => {
    let clickOnly = tooltipIsOnMap === true;

    if (onlyClick) {
        clickOnly = true;
    }

    const clickOutsideRef = React.useRef(null);

    const [show, setShow] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    let click = open;
    let setClick = setOpen;

    if (props.setOpen) {
        click = props.open;
        setClick = props.setOpen;
    }

    const onMouseOver = (e) => {
        setShow(true);
    };

    const onMouseOut = (e) => {
        setShow(false);
    };

    const onClick = () => {
        if (tooltipIsOnMap !== true && onlyClick === false) {
            setClick(!click);
        } else if (click === false) {
            setClick(true);
        }
    };

    if (tooltipIsOnMap !== true) {
        handleOutsideClick(setClick, clickOutsideRef);
    }

    let directionClass = "tmp-tooltip-right";
    switch (direction) {
        case "top":
            directionClass = "tmp-tooltip-top";
            break;
        case "bottom":
            directionClass = "tmp-tooltip-bottom";
            break;
        case "left":
            directionClass = "tmp-tooltip-left";
            break;
    }

    return (
        <div
            className={clsx("tmp-tooltip-container", props?.classes?.container)}
            onClick={onClick}
            onMouseEnter={onMouseOver}
            onMouseLeave={onMouseOut}
            ref={clickOutsideRef}
        >
            {props.hoverElement ? (
                props.hoverElement
            ) : (
                <i className="tmp-tooltip-icon fas fa-info-circle"></i>
            )}
            <Fade in={(clickOnly === false && show) || click}>
                <div className={"tmp-tooltip " + directionClass}>
                    {tooltipIsOnMap === true ? (
                        <div className="tmp-tooltip-close-container">
                            <i
                                className="tmp-tooltip-close fas fa-times"
                                onClick={() => {
                                    setClick(false);
                                }}
                            ></i>
                        </div>
                    ) : null}
                    {props.children}
                </div>
            </Fade>
        </div>
    );
};

export default Tooltip;
